import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from '../../components/ui/dialog';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../components/ui/select';

const roomTypes = ['single', 'double', 'dormitory', 'suite'];
const roomStatuses = ['available', 'occupied', 'maintenance'];
const NONE = '__none__';

const SiteCategorySelect = ({ value, onChange, categories }) => (
  <div className="space-y-2">
    <Label>Website category</Label>
    <Select value={value || NONE} onValueChange={(v) => onChange(v === NONE ? '' : v)}>
      <SelectTrigger className="border-stone-300" data-testid="site-category-select"><SelectValue /></SelectTrigger>
      <SelectContent className="bg-white">
        <SelectItem value={NONE}>Not listed on website</SelectItem>
        {categories.map((c) => (<SelectItem key={c.room_type} value={c.room_type}>{c.name} (per {c.unit})</SelectItem>))}
      </SelectContent>
    </Select>
    <p className="text-xs text-stone-500">Links this room to a GoNomikai website category for live availability.</p>
  </div>
);

export const RoomFormDialog = ({ open, onOpenChange, onSubmit, formData, setFormData, editingRoom, siteCategories = [] }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-white sm:max-w-md">
      <DialogHeader>
        <DialogTitle className="font-['Manrope']">{editingRoom ? 'Edit Room' : 'Add New Room'}</DialogTitle>
      </DialogHeader>
      <form onSubmit={onSubmit} className="space-y-4 mt-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="room_number">Room Number</Label>
            <Input id="room_number" value={formData.room_number} onChange={(e) => setFormData({...formData, room_number: e.target.value})} placeholder="101" required className="border-stone-300" data-testid="room-number-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="room_type">Type</Label>
            <Select value={formData.room_type} onValueChange={(value) => setFormData({...formData, room_type: value})}>
              <SelectTrigger className="border-stone-300" data-testid="room-type-select"><SelectValue /></SelectTrigger>
              <SelectContent className="bg-white">
                {roomTypes.map(type => (<SelectItem key={type} value={type} className="capitalize">{type}</SelectItem>))}
              </SelectContent>
            </Select>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="capacity">Capacity</Label>
            <Input id="capacity" type="number" min="1" value={formData.capacity} onChange={(e) => setFormData({...formData, capacity: e.target.value})} required className="border-stone-300" data-testid="capacity-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="price_per_night">Price/Night (₹)</Label>
            <Input id="price_per_night" type="number" min="0" step="0.01" value={formData.price_per_night} onChange={(e) => setFormData({...formData, price_per_night: e.target.value})} required className="border-stone-300" data-testid="price-input" />
          </div>
        </div>

        <div className="space-y-2">
          <Label htmlFor="status">Status</Label>
          <Select value={formData.status} onValueChange={(value) => setFormData({...formData, status: value})}>
            <SelectTrigger className="border-stone-300" data-testid="status-select"><SelectValue /></SelectTrigger>
            <SelectContent className="bg-white">
              {roomStatuses.map(status => (<SelectItem key={status} value={status} className="capitalize">{status}</SelectItem>))}
            </SelectContent>
          </Select>
        </div>

        <SiteCategorySelect value={formData.site_category} onChange={(v) => setFormData({ ...formData, site_category: v })} categories={siteCategories} />

        <div className="space-y-2">
          <Label htmlFor="amenities">Amenities (comma-separated)</Label>
          <Input id="amenities" value={formData.amenities} onChange={(e) => setFormData({...formData, amenities: e.target.value})} placeholder="WiFi, AC, TV" className="border-stone-300" data-testid="amenities-input" />
        </div>

        <div className="flex justify-end gap-3 pt-4">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="border-stone-300">Cancel</Button>
          <Button type="submit" className="bg-sage-700 hover:bg-sage-800 text-white" data-testid="save-room-button">{editingRoom ? 'Update' : 'Create'} Room</Button>
        </div>
      </form>
    </DialogContent>
  </Dialog>
);
